import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Card, Text as ThemeText, Grid, Text } from "theme-ui";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useParams } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { getSharedApp } from "../../../graphql/queries";
import { getOffersByCategory } from "../../../utils/api";
import { styles } from "../styles";
import { moneyStringToNumber, numberToMoney, numberToMoneyNoDecimal, validateMoneyInput } from "../../../utils/format";
import {
  Form,
  SingleSelect,
  Card as LumosCard,
  DataList,
  NumberInput } from '@loanpal/lumos__core';
import { useFormikContext } from 'formik';
import { object, string } from 'yup';


import HOME_IMPROVEMENT from "../../../images/HI_1.png";
import ROOF from "../../../images/ROOF_1.png";
import SOLAR from "../../../images/SOLAR_1.png";
import BATTERY from "../../../images/BATTERY_1.png";
import REMODELING from "../../../images/REMODEL_1.png";

export const CategorySelect = ({ categories }) => {
 console.log("categories", categories);

 if (!categories || !Array.isArray(categories) || categories.length === 0) {
   return null;
 }

  return (
      <Box
        sx={{
          mt: 2,
          mb: 4,
          button: {
            minHeight: 46,
            display: 'grid',
            gridTemplateColumns: '1fr 24px',
            textAlign: 'left'
          },
        }}
      >
        <SingleSelect
          placeholder="None selected"
          name="categoryId"
          label="Category"
          sxProps={{ mb: 0, maxWidth: 500 }}
          items={categories.filter(cat => cat && cat.name && cat.id).map((cat) => ({ name: String(cat.name).trim(), value: String(cat.id).trim() }))}
        />
      </Box>
  );
}

const Calculator = ({ state, send }) => {
  const { id } = useParams();
  const { categories } = state.context;
  const [SharedApp, setSharedApp] = useState(null);
  const [offers, setOffers] = useState(null);
  const [offerItems, setOfferItems] = useState([])
  const [selectedOffer, setSelectedOffer] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [categoryId] = useState(state.context.selectedCategory || null);
  const [category, setCategory] = useState(null);
  const [addressState] = useState(state.context.selectedState || null);
  const [stateSelection, setStateSelection] = useState([]);
  const [payment, setPayment] = useState();
  const [paymentAmount, setPaymentAmount] = useState({});
  const [loadingPayment, setLoadingPayment] = useState(true);
  const [offerDesc, setOfferDesc] = useState();
  const [offerName, setOfferName] = useState();
  const [minAmount, setMinAmount] = useState();
  const [maxAmount, setMaxAmount] = useState();
  const [limitations, setLimitations] = useState();
  const [timer, setTimer] = useState(null);
  const version = "2.0";
  const host = window.location.host;
  const env = "prod";
  const sandbox_promotionId = "2345f0aa-db7a-42b9-807b-9e8a82b81ae3";
  const prod_promotionId =  "26d09475-32ec-448c-bb43-9f70aea55644";

  const getCategory = (category) => {
    console.log("category", category);
    if (category === "HOME IMPROVEMENT") return HOME_IMPROVEMENT
    else if (category === "ROOFING / WINDOWS / DOORS / SIDING / GEOTHERMAL / RESTORATION") return ROOF;
    else if (category === "SOLAR") return SOLAR;
    else if (category === "STAND-ALONE BATTERY") return BATTERY;
    else if (category === "REMODELING") return REMODELING;
  }

  const getCategoryName = (category) => {
    if (category === "HOME IMPROVEMENT") return "Home Improvement";
    else if (category === "ROOFING / WINDOWS / DOORS / SIDING / GEOTHERMAL / RESTORATION") return "Roofing / Windows / Doors / Siding / Geothermal / Restoration";
    else if (category === "SOLAR") return "Solar";
    else if (category === "BATTERY") return "Battery";
    else if (category === "REMODELING") return "Remodeling";
  }

  useEffect(() => {
    fetchSharedApp(id);
    // eslint-disable-next-line
  }, [id]);

  // Initial setup: Get SharedApp, categories, and states
  useEffect(() => {
    if (SharedApp && SharedApp.clientId) {
      setSharedApp(SharedApp);
      setPaymentAmount({ amount: SharedApp.loanAmount, payment: false });
      getStates(SharedApp.clientId);
    }
    // eslint-disable-next-line
  }, [SharedApp]);

  // When categoryId changes, get category-specific data (limitations, min/max)
  useEffect(() => {
    if (SharedApp?.clientId && categoryId) {
      getCategories(SharedApp.clientId, categoryId);
    }
    // eslint-disable-next-line
  }, [categoryId]);

  // When category or state changes, reset offers and get new ones
  useEffect(() => {
    if (SharedApp?.clientId && categoryId && addressState) {
      setOffers(null); // Reset offers
      setOfferItems([]); // Reset offer items
      setSelectedOffer(""); // Reset selected offer
      setPayment(null); // Reset payment
      fetchOffers(SharedApp.clientId, categoryId, addressState, env);
    }
    // eslint-disable-next-line
  }, [categoryId, addressState])

   useEffect(() => {
       if (paymentAmount.payment && selectedOffer !== "") {
        console.log("paymentAmount", paymentAmount);
         getPayment(selectedOffer, paymentAmount.amount);
       }
     // eslint-disable-next-line
   }, [paymentAmount])

   useEffect(() => {
     if (selectedOffer && selectedOffer !== "" && paymentAmount.amount) {
      console.log("selectedOffer changed:", selectedOffer);
       setPaymentAmount({ amount: paymentAmount.amount, payment: true });
     }
   // eslint-disable-next-line
   }, [selectedOffer])

  const fetchSharedApp = async (id) => {
  try {
    const appData = await API.graphql(
      graphqlOperation(getSharedApp, { id: id })
    );
    setSharedApp(appData.data.getSharedApp);
  } catch (err) {
    console.log("error fetching SharedApp", err);
  }
}

  const fetchOffers = async (clientId, categoryId, state, env) => {
    try {
      setSpinner(true);
      const offersWithStates = await getOffersByCategory(clientId, categoryId, state, env, undefined);
       if (offersWithStates.data.length > 0) {
        setOffers(offersWithStates.data);
        let offersArrayOptions = [];
          offersArrayOptions = offersWithStates.data
            .map((element) => [
              ...offersArrayOptions,
              { name: element.productCode.includes("DEFERRED") ? `${element.productName} - ${element.name}` : `${element.name} - ${element.productName}`, value: element.id },
            ])
            .flat();
          setOfferItems(offersArrayOptions);
        console.log("offerItems", offersArrayOptions);
        setSpinner(false);
      }
    } catch (err) {
      console.log("error getting offers", err);
      setSpinner(false);
      return setOffers([]);
    }
  }

const getCategories = async (clientId, category = null) => {
    try {
    const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId
        },
      };
      // get categories
      await API.get("developerApi", "/categories", myInit0)
      .then((response) => {
        console.log("categories", response);
        if (category) {
          const cat = response.find(el => el.id === category);
          getLimitations(clientId, cat.id);
          setMinAmount(cat.minLoanAmount);
          setMaxAmount(cat.maxLoanAmount);
          setCategory(cat.name);
        }
      },
      (err) => {
        console.log("Error getting categories", err);
        setLoadingPayment(false);
      })
    } catch (err) {
      console.log("error getting categories", err);
      return false;
    }
  }

  const getStates = async (clientId) => {
     try {
       const myInit0 = {
         queryStringParameters: {
           apiId: `${clientId}ApiId`,
           apiKey: `${clientId}ApiKey`,
           clientId: clientId
         },
       };
       // get states
       await API.get("developerApi", "/states", myInit0)
       .then((response) => {
          const stateItems = response.map((stateObj) => ({
            name: stateObj.code, // You could map this to full state names if needed
            value: stateObj.code
          }));

          setStateSelection(stateItems);
       },
       (err) => {
         setLoadingPayment(false);
       })
     } catch (err) {
       console.log("error getting states", err);
       return false;
     }
   }

  const getLimitations = async (clientId, category) => {
    try {
    const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId
        },
      };
      // get categories
      await API.get("developerApi", "/limitations", myInit0)
      .then((response) => {
        const limitations = response.data.filter((element) => element.categoryId === category)
        setLimitations(limitations);
      },
      (err) => {
        console.log("Error getting limitations", err);
        setLoadingPayment(false);
      })
    } catch (err) {
      console.log("error getting limitations", err);
      return false;
    }
  }

const getPromotionId = () => {
  if (host.includes("sandox") || (env === "dev"))  {
    return sandbox_promotionId;
  } else  {
    return prod_promotionId;
  }
}

const productItems = [
    { label: 'Loan product', text: offerDesc},
    {
      label: 'Term and rate',
      text: offerName,
    }
  ];

const estimatedPayment = payment ? payment[0].calculations.map((pay) => ({
    label: pay.paymentDescription,
    text: <div>
          {loadingPayment ? (
            <SkeletonTheme baseColor="#d7d7d7" highlightColor="#f5f5f5">
              <Text variant="h3" as="h2">
                $ <Skeleton width={125} height={24} />
              </Text>
            </SkeletonTheme>
          ) : (
            <Text variant="h3" as="h2">
              {numberToMoney(pay.amount.value)}
              <span style={styles.period} color="neutral.base">
              &nbsp;{pay.interval === "MONTHLY" ? "/ month" : ""}
              </span>
            </Text>
          )}
          </div>,
  })) : {};

  const getPayment = async (offerId, loanAmount) => {
    setLoadingPayment(true);
    if (offerId === "" || loanAmount === "" || loanAmount <= minAmount || loanAmount > maxAmount || !validateMoneyInput(loanAmount)) {
      //TODO Throw errors if loanAmount is pass max or under min
      return;
    }
    try {
      const clientId = SharedApp.clientId;
      const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          promotionId: getPromotionId(),
          amount: loanAmount,
          offerId: offerId
        },
      };
      // get payment
      await API.get("developerApi", "/payments", myInit0)
      .then((response) => {
        console.log("response", response);
        setPayment(response);
        setLoadingPayment(false);
      },
      (err) => {
        console.log("Error getting payments", err);
        setLoadingPayment(false);
      })

    } catch (err) {
      console.log("error getting payments");
      setLoadingPayment(false);
      return false;
    }
  };

    const AmountInput = () => {
    const { setFieldValue, setFieldError, setErrors, values } = useFormikContext();
    return (
      <>
      <NumberInput
          key="loanAmount"
          label="Amount to finance"
          name="loanAmount"
          autoComplete="off"
          autoFocus="autoFocus"
          onBlurCapture={({ target }) => {
            const moneyValue = moneyStringToNumber(target.value);
            if (Number.isNaN(moneyValue)) return;
            setFieldValue('loanAmount', numberToMoney(moneyValue));
          }}
          onChangeCapture={({ target }) => {
            setLoadingPayment(true);
            const moneyValue = moneyStringToNumber(target.value);
            const amt = target.value;
            setPaymentAmount({ amount: moneyStringToNumber(target.value), payment: false });
            setFieldValue('loanAmount', numberToMoney(moneyValue));
            clearTimeout(timer);
            const newTimer = setTimeout(() => {
              if (selectedOffer) {
                setErrors({});
                 if (limitations.find(el => el.state === values.state)) {
                   const limits = limitations.find(el => el.state === values.state);
                   if (moneyStringToNumber(amt) < limits.minLoanAmount) {
                    setFieldError("loanAmount", `Loan amount needs to be greater than ${numberToMoneyNoDecimal(limits.minLoanAmount)}`);
                  } else if (moneyStringToNumber(amt) > limits.maxLoanAmount) {
                    setFieldError("loanAmount", `Loan amount needs to be less than ${numberToMoneyNoDecimal(limits.maxLoanAmount)}`);
                  } else {
                    setPaymentAmount({ amount: moneyStringToNumber(amt), payment: true });
                  }
                 } else {
                  if (moneyStringToNumber(amt) < minAmount) {
                    setFieldError("loanAmount", `Loan amount needs to be greater than ${numberToMoneyNoDecimal(minAmount)}`);
                  } else if (moneyStringToNumber(amt) > maxAmount) {
                    setFieldError("loanAmount", `Loan amount needs to be less than ${numberToMoneyNoDecimal(maxAmount)}`);
                  } else {
                    setPaymentAmount({ amount: moneyStringToNumber(amt), payment: true });
                  }
                }
              }
            }, 2000)
            setTimer(newTimer)
          }}
        />
      </>
    )
}

  return (
    <Form
      initialValues={{
        offerId: "",
        loanAmount: ""
      }}
      enableReinitialize={false}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={object({
        offerId: string().required("Please select an offer"),
        loanAmount: string()
          .required("Required")
          .test("currenty", `Please enter a currency value`, val => validateMoneyInput(val))
      })}
      onSubmit={({...values}) => {
        const { offerId } = values;
        console.log("offerId", offerId);
      }}
      showSummary={false}
    >
    <Box
      sx={{
        maxWidth: "960px",
        backgroundColor: "#ffffff",
        mx: "auto",
         display: 'flex',
        flexDirection: 'column'
      }}>
      <Box sx={{ display: 'flex', height: '100%', marginTop: "20px" }}>
        {spinner && !offers && (
          <Box sx={{ minHeight: 35 }}>
            <Spinner style={styles.spinner} size="40" />
          </Box>
        )}
      </Box>
      <Card style={styles.cardBox}>
      {categories && categories.length > 0 && (
        <CategorySelect categories={categories} />
      )}
             {console.log("Rendering stateSelection:", stateSelection, "Length:", stateSelection?.length)}
       {stateSelection && stateSelection.length > 0 && (
       <Box
      sx={{
        button: {
          minHeight: 46,
          display: 'grid',
          gridTemplateColumns: '1fr 24px',
          textAlign: 'left'
        },
      }}
    >
      <Flex
        direction="row"
        wrap="nowrap"
        gap="1rem"
      >
      <SingleSelect
         name="state"
         label="State / Territory"
         items={stateSelection.filter(state => state && state.name).map(state => ({ name: state.name, value: state.code || state.value || state.name }))}
         sxProps={{ mb: 0, width: "100%" }}
       />
      <Box>
        {spinner && (
          <Box sx={{ minHeight: 35, marginTop: "25px" }}>
            <Spinner style={styles.spinner} size="40" />
          </Box>
        )}
        </Box>
        </Flex>
      </Box>
      )}
      {offers && (
        <>
        <Box
          sx={{
            button: {
              minHeight: 46,
              display: 'grid',
              gridTemplateColumns: '1fr 24px',
              textAlign: 'left'
            },
          }}
        >
        <Flex
          direction="row"
          wrap="nowrap"
          gap="1rem"
        >
          <SingleSelect
            name="offerId"
            label="Offer"
            items={offerItems}
            sxProps={{ mb: 0, width: "100%" }}
            disabled={!spinner}
              dangerouslyOnChange={(e) => {
               console.log("selectedOffer", e);
               const offer = offers.find(({id}) => id === e )
               console.log("offers", offers);
               console.log("offer", offer);
               if (offer) {
                setOfferDesc(offer.productDescription);
                setOfferName(offer.name);
                getPayment(offer.id, paymentAmount.amount);
               }
               setSelectedOffer(e);
               // Trigger payment calculation with current amount if available
               if (paymentAmount.amount) {
                 setPaymentAmount({ amount: paymentAmount.amount, payment: true });
               }
             }}
          />
        </Flex>
        </Box>
        <Box sx={{ mt: 2 }}>
          <AmountInput />
        </Box>
        </>
      )}
      </Card>
      {payment && version === "2.0" &&
      <LumosCard
          header={{
            title: (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img src={getCategory(category)} alt={getCategoryName(category)} style={styles.catLogo} />
                {getCategoryName(category)} loan estimated loan details
              </Box>
            ),
          }}
        >
      <Box
      sx={{
          pt: 3,
          mt: 3,
          borderTop: "1px solid",
          borderTopColor: "neutral.l3",
        }}>
        <Grid columns={[1, 1, '1fr 2fr 2fr']}>
          <Box
            sx={{
              borderRight: '1px solid',
              borderColor: ['transparent', 'transparent', 'neutral.l3'],
              mb: 3,
            }}
          >
            <div>Loan amount</div>
            <ThemeText variant="h3" as="h2">
              {numberToMoney(paymentAmount.amount)}
            </ThemeText>
          </Box>
          <Box
            sx={{
              borderRight: '1px solid',
              borderColor: ['transparent', 'transparent', 'neutral.l3'],
              mb: 3,
              pr: 2,
            }}
          >
            <DataList columns={1} items={productItems} />
          </Box>
          <Box sx={{ mb: 3 }}>
            <DataList columns={1} items={estimatedPayment} />
          </Box>
        </Grid>
      </Box>
      </LumosCard>}
    </Box>
    </Form>
  );
};

export default Calculator;